var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllumerRepetiteurScope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79 63.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2458",
    d: "M3 46.499v10a4 4 0 0 0 4 4h65a4 4 0 0 0 4-4v-10H3m-3-3h79v13a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 889",
    d: "M25.664 55.895h20.672a2.682 2.682 0 0 0 2.664-2.7 2.682 2.682 0 0 0-2.664-2.7H25.664a2.682 2.682 0 0 0-2.664 2.7 2.682 2.682 0 0 0 2.664 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 890",
    d: "M53.876 55.899a2.7 2.7 0 1 1 2.7-2.7 2.7 2.7 0 0 1-2.7 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 888",
    d: "m31.457 22.64-6.851-8.841a1.593 1.593 0 0 0-1.232-.49H0v-3h23.35a4.547 4.547 0 0 1 3.61 1.63l.01.013 4.486 5.787L44.015 1.524l.037-.041a4.253 4.253 0 0 1 .974-.8 4.905 4.905 0 0 1 6.025.8l.037.041 6.806 8.787H79v3H56.421l-7.632-9.854a1.946 1.946 0 0 0-2.217-.2 1.289 1.289 0 0 0-.26.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllumerRepetiteurScope);
export default __webpack_public_path__ + "static/media/allumer-repetiteur-scope.ab5765c2165e885c1ef95d326292028e.svg";
export { ForwardRef as ReactComponent };